import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
   0% {
      transform: scale(1);
      opacity: 1;
   }
   50% {
      transform: scale(1.3);
      opacity: 0.6;
   }
   100% {
      transform: scale(1);
      opacity: 1;
   }
`;

export const StyledRecordingDot = styled.span`
   display: inline-block;
   width: 10px;
   height: 10px;
   border-radius: 50%;
   background-color: currentColor;
   flex-shrink: 0;
   animation: ${pulse} 1.2s ease-in-out infinite;
   will-change: transform, opacity;
`;

StyledRecordingDot.displayName = 'StyledRecordingDot';
